import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, useLocation } from "react-router-dom";
import App from "./App";
import { trackEvent } from "./utils/track";

// styles for this kit
import "assets/css/bootstrap.min.css";
import "assets/scss/now-ui-kit.scss?v=1.5.0";
import "assets/demo/demo.css?v=1.5.0";
import "assets/demo/nucleo-icons-page-styles.css?v=1.5.0";

function RootWithTracker() {
  const location = useLocation();
  useEffect(() => {
    trackEvent({ event_type: "page_view", target_id: location.pathname || "/" });
  }, [location.pathname]);
  return <App />;
}

function Root() {
  return (
    <BrowserRouter>
      <RootWithTracker />
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

// React 18 StrictMode 会与 React Router v5 冲突，导致 URL 变化时组件不重新渲染
// 参见: https://github.com/remix-run/react-router/issues/7209
root.render(<Root />);
